<template>
    <v-layout v-if="aboutView && aboutView.isAboutMessageVisible">
        <v-layout v-if="aboutView && aboutView.message && aboutView.isAboutMessageVisible" pa-2>
            <v-flex xs12 class="about-view__wrapper">
                <v-card class="about-view">
                    <v-flex>
                        <v-flex tag="h2" data-qe-id="about_Title_Header">
                            {{aboutTitleHeader}}
                            <edit-about
                                :chapter-about="aboutView"
                                v-if="aboutView && aboutView.canEdit && aboutView.isAboutMessageVisible"
                                @editToggled="toggleEditMode"
                                :class="['about-view__edit-button', isEditMode && 'about-view__edit-button--on-edit']"
                                class="about-view__edit-button"></edit-about>
                        </v-flex>
                    </v-flex>
                  <div v-if="!isEditMode">
                    <v-card-text class="about-view__message-text" v-html="aboutMessage">
                    </v-card-text>
                    <v-flex text-xs-right v-if="showMoreBtn || aboutMessageIncludesImage">
                      <v-btn
                          @click="showDesc=true"
                          data-qe-id="about_show_more_btn"
                          flat
                          class="primary_btn transparent small">
                        {{communityCommonConstant.SHOW_MORE_BUTTON}}
                      </v-btn>
                    </v-flex>
                  </div>
                </v-card>
            </v-flex>
            <v-dialog width="630" v-model="showDesc" data-qe-id="about_dialog_show_more">
                <v-card>
                    <v-flex class="about">
                        <v-layout
                            row
                            wrap
                            absolute
                            class="about__cont">
                            <v-flex class="xs12">
                                <h2 data-qe-id="about_dialog_title_header">{{communityCommonConstant.about.TITLE}}</h2>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex
                        xs12
                        class="about__cont__imageblock"
                        v-if="aboutMessageIncludesImage">
                        <img data-qe-id="about_dialog_image" :src="aboutView.aboutMessageImage.url" v-if=" aboutView.aboutMessageImage && aboutView.aboutMessageImage.url" />
                    </v-flex>
                    <v-flex>
                        <v-card-text data-qe-id="about_dialog_about_message" class="dialog-box__message-text dialog-box__message-desc-border" v-html="aboutView.message">
                        </v-card-text>
                        <v-flex text-right>
                            <v-btn
                                @click="showDesc=false"
                                data-qe-id="close_dialog_btn"
                                flat
                                class="dialog-box__btn-align">
                                {{communityCommonConstant.CLOSE_BUTTON}}
                            </v-btn>
                        </v-flex>
                    </v-flex>
                </v-card>
            </v-dialog>
        </v-layout>
        <v-layout v-if="!aboutView.message && aboutView.canEdit && aboutView.isAboutMessageVisible"
                  class="about-view__wrapper about-view__wrapper__new-about">
            <edit-about :chapter-about="aboutView"></edit-about>
        </v-layout>
    </v-layout>
</template>

<script>
    import { mapGetters } from "vuex";
    import { communityCommonConstant } from "../communityCommon.constant";
    import { storeGetters } from "../../../store/storeGetters.constant";
    import EditAbout from "./EditAbout";
    import { capitalizedString } from "../../../common/utils/utils";

    export default {
        name: "About",
        components: {
            EditAbout,
        },
        data: () => {
            return {
                communityCommonConstant,
                showDesc: false,
                isEditMode: false,
            };
        },
        computed: {
            ...mapGetters({
                aboutView: `chapter/${storeGetters.aboutView}`,
            }),
            aboutTitleHeader() {
                if (this.$store) {
                    if (this.$store.getters[storeGetters.communityName] === 'Businesses') {
                        return `${communityCommonConstant.about.ABOUT_COMMUNITY} Around Me`;
                    }
                    return `${communityCommonConstant.about.ABOUT_COMMUNITY} ${capitalizedString(this.$store.getters[storeGetters.communityName])}`;
                }
             },
            aboutMessage() {
                const dots = "...";
                return this.aboutView.message.length >
                    communityCommonConstant.CHAPTER_CHAIR_MESSAGE_SHORT_TEXT_LENGTH ?
                    this.aboutView.message.substring(
                        0,
                        communityCommonConstant.CHAPTER_CHAIR_MESSAGE_SHORT_TEXT_LENGTH,
                    ) + dots :
                    this.aboutView.message;
            },
            showMoreBtn() {
                return (
                    this.aboutView.message.length >
                    communityCommonConstant.CHAPTER_CHAIR_MESSAGE_SHORT_TEXT_LENGTH
                );
            },
            aboutMessageIncludesImage() {
              return (this.aboutView && this.aboutView.aboutMessageImage && this.aboutView.aboutMessageImage.url.includes('/communityaboutimage'));
            },
        },
        methods: {
          toggleEditMode(val) {
            this.isEditMode = val;
          },
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../../common/styles/_colors.scss";
    @import "../../../common/styles/_responsive.scss";

    .about-view {
        border-radius: 4px;
        box-shadow: none;
        padding: 0;
        margin: 0;

        &__divider-border {
            border-color: $ypo-about-border;
        }

        &__message-text {
            font-size: 12px;
            line-height: 20px;
            color: $ypo_blue;
            padding: 10px 15px 5px 15px;
            word-wrap: break-word;
            text-overflow: ellipsis;
            overflow: hidden;
        }

        &__btn-show-more {
            font-weight: bold;
            color: $ypo-blue;
        }

        &__edit-button {
            position: absolute;
            top: 0;
            right: 0;

          &--on-edit {
            position: relative;
          }
        }
    }

    .dialog-box {
        &__message-format {
            text-align: center;
            height: 120px;
            background-color: $ypo-dark-background-gray;
            font-weight: lighter;
            color: $white;
        }

        &__message-text {
            font-weight: lighter;
            color: $ypo-duskblue;
            text-align: left;
            text-overflow: ellipsis;
            overflow: hidden;
            padding-top: 8px;
            padding-left: 25px;
            background-color: $white;
            word-wrap: break-word;
            font-size: 14px;
        }

        &__btn-align {
            color: $ypo-cta;
            font-weight: bold;
            margin-right: 0px;
            padding: 0px;
        }

        &__message-desc-border {
            border-bottom: 1px solid $ypo-duskblue;
        }

        &__edit-btn {
            color: $ypo-dark-background-gray;
        }
    }

    .about {
        position: relative;
        background: $ypo-dark-background-gray;
        min-height: 150px;

        &__img-upload-pos {
            background: $ypo-extra-light-gray;
            max-height: 300px;
        }

        &__header {
            text-align: center;
            height: 120px;
            background-color: $ypo-dark-background-gray;
            font-weight: lighter;
            color: $white;
            padding-top: 8px;
        }

        h2 {
            color: $white;
            margin: 50px 0 0 20px;
            font-size: 31px;
            font-weight: lighter;
        }

        &__cont {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            text-align: center;

            &__imageblock {
                text-align: center;

                img {
                    max-height: 150px;
                    margin: 10px;
                    @include breakpoint(xs) {
                        margin: 0;
                        width: 100%;
                    }
                }
            }
        }
    }

    .about-view__wrapper {
        border: 1px solid $ypo-medium-gray;
        border-radius: 4px;

        &__new-about {
          display: flex;
          justify-content: center;
          padding: 10px 20px;
        }
    }
</style>
